module.exports = __webpack_public_path__ + "static/media/recortes_home_01.c3f6374f.jpg";